import { render } from "./ReportOrderStatusByTime.vue?vue&type=template&id=4a754029&scoped=true"
import script from "./ReportOrderStatusByTime.vue?vue&type=script&lang=js"
export * from "./ReportOrderStatusByTime.vue?vue&type=script&lang=js"

import "./ReportOrderStatusByTime.vue?vue&type=style&index=0&id=4a754029&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4a754029"

export default script